import React from 'react';
import styles from './FriendsHeader.module.scss';

interface FriendsHeaderProps {
  isLoading: boolean;
}

const FriendsHeader: React.FC<FriendsHeaderProps> = ({ isLoading }) => {
  return (
    <div
      className={`${styles.friendsHeader} ${isLoading ? styles.friendsHeader_loading : ''}`}
    >
      <div className={styles.friendsHeader__content}>
        <div className={styles.friendsHeader__title}>Пригласи своих друзей</div>
        <div className={styles.subtitle}>
          и получай 10% от их дохода на постоянной основе.
        </div>
      </div>
    </div>
  );
};

export default FriendsHeader;
